module.exports = __webpack_public_path__ + "static/media/info-keypoint1.778e8d43.png";